module.exports = __webpack_public_path__ + "media/bootstrap-icons/reception-4-6619f997.svg";